// Copied from design-system/Tooltip in retool_development
import React from 'react'
import classNames from 'classnames'
import { Tooltip as AntTooltip } from 'antd'
import 'antd/lib/tooltip/style/index'
import './Tooltip.scss'

const Tooltip = (props) => {
  return <AntTooltip {...props} overlayClassName={classNames('retool-tooltip', props.overlayClassName)} />
}

export default Tooltip
